<template>
    <div class="col-6 col-sm-3 pb-1 font-size-xs mb-1"> {{ label }} 
    <v-select
      :options="options"
      multiple
      push-tags
      v-model="appliedFilters"
    ></v-select>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import store from '../store';
import { isEntityVisible } from '../filter.function';

export default {
  name: 'SelectFilter',
  store,
  props: ['options', 'label', 'name'],
  components: { vSelect },
  data: function() {
    return {
      appliedFilters: store.getters.filters.casino && store.getters.filters.casino.find(e => e.type === this.name) ? this.options.filter(e => store.getters.filters.casino.find(e => e.type === this.name).value.includes(e.code)) : undefined ,
    };
  },
  methods: {
    filterResults(appliedFilters) {
      if (appliedFilters.length) {
        if (store.getters.filters.casino.find((e) => e.type == this.name)) {
          store.getters.filters.casino.find(
            (e) => e.type == this.name
          ).value = appliedFilters;
            store.commit('setFilters', store.getters.filters);

        } else {
          store.getters.filters.casino.push({
            type: this.name,
            value: appliedFilters,
          });
            store.commit('setFilters', store.getters.filters);

        }
      } else {
        store.commit('setFilters', {
          ...store.getters.filters,
          casino: store.getters.filters.casino.filter(
            (e) => e.type !== this.name
          ),
        });
      }

        const finalResults = [];
        for (let result of store.getters.results) {
            result.visible = isEntityVisible(store.getters.filters.casino, result);
            finalResults.push(result)
        }
        store.commit('setResults', finalResults);
    },
  },

  watch: {
    appliedFilters: function(val) {
        
      this.filterResults(val.map((e) => e.code));
    },
  },
};
</script>
